{
  "title": "Advisor Contact",
  "description": "Access (Rep Code Access on a user) and designation (which rep code an advisor contact represents) are resolved separately. Use Client View to search for a client and preview the advisors they will see.",
  "pageConfigurationInfo": "Advisor Contact widget display options (name, phone, email, address, and related toggles) are configured per page under",
  "noAccess": "You do not have permission to view Advisor Contact administration.",
  "comingSoon": "Coming soon",
  "none": "— none —",
  "noneOption": "— None —",
  "required": "* Required",
  "tabs": {
    "repCodeManagement": "RepCode Management",
    "roleLibrary": "Role Library",
    "userProfile": "User Profile",
    "advisorContact": "Advisor Contact",
    "clientView": "Client View"
  },
  "repCodeManagement": {
    "title": "RepCode Management",
    "description": "Code and name are editable here. Assigned users is access, set on each person's user profile. Designation of which advisor contact represents a code is set on the Advisor Contact tab."
  },
  "roleLibrary": {
    "title": "Advisor Role Library",
    "description": "Order sets display priority. Create, rename, delete, and reorder locally, then save to apply. Records with no role assigned always sort after every role here. While inheriting from the parent organization, the library is read-only and this organization has no local roles of its own.",
    "newRoleName": "New Role",
    "roleName": "Role name",
    "rankPrefix": "Rank",
    "dragHandle": "Drag to reorder",
    "deleteRole": "Delete role",
    "saveChanges": "Save",
    "discardChanges": "Discard",
    "saveFailed": "Could not save role library changes",
    "nameRequired": "Enter a role name",
    "nameDuplicate": "Another role already uses this name",
    "emptyState": "No roles yet. Add a role to start building the library.",
    "inherited": "Inherited",
    "useParentDisplayRoles": "Inherit display roles from parent organization",
    "inheritModal": {
      "turnOnTitle": "Inherit roles from the parent organization?",
      "turnOnBody": "This organization's own roles will be archived and replaced by the parent's read-only library. While inheriting you cannot add, rename, reorder, or delete roles.",
      "rolesArchived": "local role(s) will be archived",
      "contactsReset": "advisor contact(s) will have their display role reset to blank",
      "turnOnNoImpact": "This organization has no local roles, so nothing will be archived.",
      "turnOffTitle": "Stop inheriting roles?",
      "turnOffBody": "This organization's role library will be empty until you rebuild it from scratch. Nothing is copied down from the parent.",
      "turnOffImpact": "Every advisor contact and user currently assigned a parent role will have it reset to blank — in this organization and in every child organization that inherits from it.",
      "confirm": "Continue"
    },
    "deleteModal": {
      "title": "Delete this role?",
      "inUse": "Deleting this role will reset the display role to blank on every Advisor Contact currently holding it when you save. This cannot be undone.",
      "notInUse": "Nobody is currently using this role. It is safe to delete.",
      "advisorContacts": "advisor contact(s)",
      "confirm": "Delete Role"
    },
    "saveModal": {
      "title": "Save role library?",
      "body": "Creates, renames, deletions, and the new display order will apply immediately for every Advisor Contact and client widget that uses these roles."
    }
  },
  "userProfile": {
    "title": "User Profile",
    "description": "Review user identity here, and update display role and rep codes from each row. Rep codes on a user are access, and they are what RepCode Management's assigned users and Client View's connection check are both computed from."
  },
  "contacts": {
    "title": "Advisor Contact",
    "description": "The canonical, client-facing identity: name, phone, email, address and display role. Add one manually for advisors with no system access, or link a user profile — linking seeds name, phone and email once from that user, then this record is edited independently and never flows back. Use Designated For to choose which rep code(s) this identity represents on Client View.",
    "addManual": "Add Advisor Contact (manual)",
    "newFirstName": "New",
    "newLastName": "Advisor",
    "columns": {
      "name": "Name",
      "organization": "Organization",
      "linkedUser": "Linked User",
      "phone": "Phone",
      "email": "Email",
      "address": "Address",
      "displayRole": "Display Role",
      "designatedFor": "Designated For"
    },
    "firstName": "First name",
    "lastName": "Last name",
    "phone": "Phone",
    "extension": "Ext.",
    "email": "Email",
    "address": "Address",
    "displayRole": "Display Role",
    "designatedFor": "Designated For",
    "linkedUserNone": "— None (manual) —",
    "manualIdentity": "Manual",
    "inherited": "Inherited",
    "override": "Override",
    "designate": "Designate…",
    "designateSaveLinkFirst": "Save the linked-user change before editing designated rep codes.",
    "designateLinkMismatch": "Remove designated rep codes the linked user does not hold, then save again.",
    "linkedUserSearchTruncated": "Showing {{shown}} of {{total}} matches. Keep typing to narrow.",
    "linkedUserSearchFailed": "Could not search users.",
    "linkedUserNoOptions": "No users match this search.",
    "undesignate": "Remove designation",
    "designateHeldBySameUser": "(held by {{name}})",
    "designateSameUserConflict": "This user already has another advisor contact designated for: {{codes}}. Remove the code there first.",
    "overriddenLocally": "Overridden locally",
    "emptyState": "No advisor contacts yet. Add one manually or link an existing user.",
    "noSearchMatches": "No advisor contacts match this search.",
    "firstNameRequired": "Enter a first name",
    "invalidPhone": "Enter a valid phone number",
    "invalidExtension": "Enter up to 10 digits",
    "saveFailed": "Could not save advisor contact",
    "deleteFailed": "Could not delete advisor contact",
    "overrideFailed": "Could not create a local override",
    "useParentAdvisorContacts": "Show advisor contacts from parent organizations",
    "brokenIndicator": "Departed",
    "departedSuffix": "(departed)",
    "brokenDesignationDisabled": "Designations are unavailable while the linked user is inactive. Relink this contact to an active user or unlink it first.",
    "brokenNotice": {
      "title": "Linked user is no longer active",
      "body": "This linked user has departed or been deactivated, so this contact is no longer linked to an active user. Relink it to an active user below, or unlink it to keep it as a manual identity. Its designated rep codes have already been cleared.",
      "unlink": "Unlink",
      "unlinkPending": "This contact will be unlinked and kept as a manual identity when you save.",
      "unknownUser": "This advisor's linked user",
      "inheritedResolve": "The parent organization must resolve this departed advisor."
    },
    "modal": {
      "createTitle": "Add advisor contact",
      "editTitle": "Edit advisor contact",
      "viewTitle": "View advisor contact"
    },
    "deleteModal": {
      "title": "Delete this advisor contact?",
      "body": "This archives {{name}} and frees any designated rep codes. This cannot be undone.",
      "confirm": "Delete"
    },
    "inheritModal": {
      "turnOnTitle": "Show parent advisor contacts?",
      "turnOnBody": "Advisor contacts from parent organizations will become visible to this organization's clients.",
      "turnOffTitle": "Stop showing parent advisor contacts?",
      "turnOffBody": "Advisor contacts from parent organizations will no longer be visible to this organization's clients.",
      "turnOffCount": "inherited advisor contact(s) on this page will no longer be visible to clients.",
      "turnOffDescendants": "Child organizations that inherit from this organization are affected too.",
      "confirm": "Continue"
    },
    "pruneModal": {
      "title": "Some designations will be removed",
      "body": "The newly linked user does not hold these codes, so they will be dropped:",
      "confirm": "Continue"
    }
  },
  "clientView": {
    "title": "Client View",
    "description": "Search for a client, then pick an account or household to preview the advisors they will see.",
    "search": "Search clients",
    "searchTruncated": "Showing {{shown}} of {{total}} matches. Keep typing to narrow.",
    "searchFailed": "Could not search clients.",
    "selectClient": "Search for a client above to preview advisor visibility.",
    "grainLabel": "Scope",
    "grainAccount": "Account",
    "grainHousehold": "Household",
    "selectAccount": "Select account",
    "selectHousehold": "Select household",
    "selectPageConfiguration": "Select page configuration",
    "selectScope": "Select an account or household to preview resolved advisors.",
    "sections": {
      "resolvedAdvisors": "Resolved advisors"
    },
    "householdReadOnly": "To change visibility, switch to Account scope and edit per account.",
    "notEnabled": "Resolution is not enabled for this firm.",
    "toggleFailed": "Could not update visibility",
    "emptyList": "No clients match this search.",
    "emptyAccounts": "This client has no accounts to preview.",
    "emptyHouseholds": "This client is not in a household to preview.",
    "scopeLoadFailed": "Could not load accounts or households for this client.",
    "accountsLoadMore": "Showing {{shown}} of {{total}} accounts. Scroll for more.",
    "noAccountMatches": "No accounts match this search.",
    "noAccountMatchesYet": "No match in the first {{shown}} accounts. Refine or clear the search.",
    "emptyResolution": "No advisors resolve for this scope.",
    "emptyPreview": "No advisors are visible to this client for the selected scope.",
    "missingPlacement": "Advisor Contact isn't on the {{pageType}} page configuration.",
    "missingPagePlacement": "Advisor Contact isn't on {{pageName}}.",
    "usingOptions": "Using options from the {{pageType}} page configuration",
    "usingPageOptions": "Using options from {{pageName}}",
    "pageType": {
      "INDIVIDUAL": "Individual",
      "NON_INDIVIDUAL": "Non-Individual",
      "HOUSEHOLD": "Household"
    },
    "columns": {
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "displayRole": "Display Role",
      "visibility": "Visibility"
    },
    "preview": {
      "title": "Contact Your Advisor"
    }
  }
}
